var _style, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "calendar-icon_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 48 45",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".calendar-icon_svg__st0{fill:#fff}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "calendar-icon_svg__st0",
    d: "M37.6 4.2V0h-3.4v4.2H13.9V0h-3.4v4.2H0V45h48V4.2H37.6zM10.8 5.9v4.5h2.8V5.9h20.9v3.9h2.8V5.9h8.9v7.3H1.7V5.9h9.1zM1.7 43.3V17.6h44.6v25.7H1.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "calendar-icon_svg__st0",
    d: "M.1 4.3H48v13.3H.1z"
  })));
}
export default SvgCalendarIcon;